
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/overview",
      function () {
        return require("private-next-pages/profile/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/overview"])
      });
    }
  